import { IconProps } from '../../atoms/icons/icon'

export const MAPPED_STANDARD_SERVICE_PROVIDER_ICONS: Record<
  string,
  IconProps['name']
> = {
  '65de7c6bc128a1016e56a1e0': 'challenge-sport',
  '65de7c72c128a1016e56b06a': 'riddle-strategy',
  '65de7c75c128a1016e56beef': 'game-discovery',
  '65de7c77c128a1016e56cd6f': 'coaching-training',
  '65de7c7ac128a1016e56dbf5': 'cocktail-party',
  '664cac3321ae591e2a3e7637': 'event-project-manager',
  '65de7c7dc128a1016e56ea82': 'breakfast',
  '65de7c7fc128a1016e56f8fd': 'lunch',
  '65de7c81c128a1016e570788': 'dinner',
}
